import React, { useRef } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';

const PricingSection = () => {
    const sliderRef = useRef(null); // Create a reference to the slider

    const settings = {
        dots: true,
        infinite: true,
        speed: 1000, // Slide speed for smooth transition
        autoplay: true, // Enable autoplay for continuous scrolling
        autoplaySpeed: 500, // Set the autoplay speed (2 seconds per slide)
        slidesToShow: 3, // Number of slides to show at once on desktop
        slidesToScroll: 1, // Number of slides to scroll at once
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
        ],
    };

    const pricingData = [
        {
            name: 'Honda City ',
            city: '',
            image: '/images/ourfleet/2.jpg',
            initialChange: '$2.50',
            perKM: '₹13',
            perTraffic: '$1.50',
            passengers: '4+1',
        },
        {
            name: 'Ertiga',
            city: '',
            image: '/images/ourfleet/3.jpg',
            initialChange: '$2.50',
            perKM: '₹14',
            perTraffic: '$1.50',
            passengers: '6+1',
        },
        {
            name: 'Innova ',
            city: '',
            image: '/images/ourfleet/5.jpg',
            initialChange: '$2.50',
            perKM: '₹17',
            perTraffic: '$1.50',
            passengers: '6+1',
        },
        {
            name: 'Swift Desire ',
            city: '',
            image: '/images/ourfleet/1.jpg',
            initialChange: '$2.50',
            perKM: '₹12',
            perTraffic: '$1.50',
            passengers: '4+1',
        },
        {
            name: 'BMW ',
            city: '',
            image: '/images/ourfleet/9.jpg',
            initialChange: '$2.50',
            perKM: '-',
            perTraffic: '$1.50',
            passengers: '4+1',
        },
        {
            name: 'Tempo Travller ',
            city: '',
            image: '/images/ourfleet/12.jpg',
            initialChange: '$2.50',
            perKM: '-',
            perTraffic: '$1.50',
            passengers: '13',
        },
    ];

    // Function to pause the slider when a card is clicked
    const handleCardClick = () => {
        if (sliderRef.current) {
            sliderRef.current.slickPause(); // Pause the slider when the card is clicked
        }
    };

    // Function to resume the slider when the mouse leaves the card
    const handleMouseLeave = () => {
        if (sliderRef.current) {
            sliderRef.current.slickPlay(); // Resume the slider when the mouse leaves
        }
    };

    return (
        <section className="pricing-section-four py-1 p-0">
            <div className="container">
                <div className="sec-title text-center">
                    <span className="sub-title darkcolorrr fs-6 pt-4">Select a plan that suits</span>
                    <h2 className="letters-slide-up text-split" style={{ fontFamily: 'Baskerville Old Face', color: '#0C0095' }}>Choose Your Cab to <br />Ride !</h2>
                </div>
                <div className="outer-box">
                    <Slider {...settings} className='p-3' ref={sliderRef}>
                        {pricingData.map((item, index) => (
                            <div
                                className="pricing-block-four borderrp"
                                key={index}
                                onClick={handleCardClick}
                                onMouseLeave={handleMouseLeave}
                            >
                                <div className="inner-box">
                                    <div className="image-box">
                                        <figure className="image">
                                            <img src={item.image} alt={item.name} />
                                        </figure>
                                    </div>
                                    <div className="content border">
                                        <div className="car-detail text-center  align-content-center">
                                            <h4 className="car-name text-white  pr-3">{item.name}</h4>
                                            <div className="city text-white">{item.city}</div>
                                        </div>
                                        <ul className="feature-list text-center border">
                                            <li>Per KM: <span className="price text-center">{item.perKM}</span></li>
                                            <li>Passengers: <span className="price text-center">{item.passengers}</span></li>
                                        </ul>


                                        <div className="btn-box">
                                            <Link to="/booking" className="theme-btn btn-style-two hover-light">
                                                <span className="btn-title">Book Your Cab</span>
                                            </Link>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default PricingSection;